import { render, staticRenderFns } from "./Wise_contactsbusiness1.vue?vue&type=template&id=56cf46a6&scoped=true"
import script from "./Wise_contactsbusiness1.vue?vue&type=script&lang=js"
export * from "./Wise_contactsbusiness1.vue?vue&type=script&lang=js"
import style0 from "./Wise_contactsbusiness1.vue?vue&type=style&index=0&id=56cf46a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf46a6",
  null
  
)

export default component.exports